import React from 'react'
import injectSheet from 'react-jss'
import styles from './teachers.styles'
import Section from '../../../../shared/section/section'
import Teacher from './teacher/teacher.container'
import AddTeacher from './add-teacher/add-teacher.container'
import { Table, HeadCell } from 'pobble-components/dist/table'
import Button from 'pobble-components/dist/button'
import { ENV } from 'pobble-components/dist/setup'
import dateFns from 'date-fns'
import { useSubscriptionDetails } from 'pobble-components/dist/subscriptions/utils'

import Tooltip from 'pobble-components/dist/tooltip'
import InfoIcon from 'react-icons/lib/fa/info-circle'

const Teachers = ({
  classes,
  pending,
  teachers,
  onBuyGroupSub,
  groupSubId,
  ownedGroupSub,
  nbOfGroupSubs,
  totalOfGroupSubs,
  canSeeGroupSeatsOptions,
  expiry
}) => {
  const { isInModerationSchool } = useSubscriptionDetails()

  return (
    !pending && (
      <Section title="Teachers" className={classes.section}>
        <p className={classes.intro}>
          On this page you can invite teacher colleagues to join your school on
          Pobble
          {canSeeGroupSeatsOptions && (
            <span> and manage your school’s paid subscriptions</span>
          )}
          . By inviting teachers to join your school they can easily share
          exciting lessons, access moderation files, manage pupils, build an
          evidence bank, and more!
        </p>
        {canSeeGroupSeatsOptions && (
          <div className={classes.subsTable}>
            <div className={classes.subsStat}>
              <strong>{teachers.length}</strong>
              <span>
                teacher
                {teachers.length > 1 ? 's' : ''} in my school
              </span>
            </div>
            <div className={classes.subsStat}>
              <strong>{totalOfGroupSubs || 0}</strong>
              <span>
                subscription
                {totalOfGroupSubs > 1 ? 's' : ''} purchased
              </span>
            </div>
            <div className={classes.subsStat}>
              <strong>{nbOfGroupSubs || 0}</strong>
              <span>
                subscription
                {nbOfGroupSubs > 1 ? 's' : ''} available
              </span>
            </div>
            {expiry && (
              <div className={classes.subsStat}>
                <strong>{`${dateFns.format(expiry, 'DD/MM/YYYY')}`}</strong>
                <span>renews on</span>
              </div>
            )}
            <div>
              {ownedGroupSub &&
                ownedGroupSub.subscriptions_group &&
                ownedGroupSub.subscriptions_group.id && (
                  <Button tall primary action={() => onBuyGroupSub(groupSubId)}>
                    Buy more subscriptions
                  </Button>
                )}
              {!ownedGroupSub && (
                <Button
                  tall
                  primary
                  href={`https://static.pobble.com/get-group-subscription${
                    ENV !== 'prod' ? '-stg' : ''
                  }`}>
                  Buy more subscriptions
                </Button>
              )}
            </div>
          </div>
        )}
        {!!teachers.length && (
          <Table>
            <thead>
              <tr>
                <HeadCell className={classes.left}>Name</HeadCell>
                <HeadCell className={classes.left}>Registered email</HeadCell>
                <HeadCell className={classes.left}>Last login</HeadCell>
                {canSeeGroupSeatsOptions && (
                  <HeadCell className={classes.left}>
                    Subscription
                    {isInModerationSchool && (
                      <sup>
                        <Tooltip
                          content={
                            'Your school has an active Moderation subscription'
                          }>
                          <InfoIcon className={classes.iIcon} />
                        </Tooltip>
                      </sup>
                    )}
                  </HeadCell>
                )}
                <HeadCell className={classes.left}>Admins</HeadCell>
                <HeadCell />
              </tr>
            </thead>
            <tbody>
              {teachers.map(teacher => (
                <Teacher key={teacher.account.id} id={teacher.account.id} />
              ))}
            </tbody>
          </Table>
        )}
        <div className={classes.add}>
          <AddTeacher />
        </div>
      </Section>
    )
  )
}

export default injectSheet(styles)(Teachers)
